import type { GetElementClassNameFn } from "@b2bportal/core-themes";
import type { IResendEmailData } from "@tenant/self-serve";
import { Loading } from "@tenant/ui";

export interface IResendProcessingProps {
  cn: GetElementClassNameFn;
  copy: IResendEmailData["copy"];
}

export const ResendProcessing = (props: IResendProcessingProps) => {
  const { cn, copy } = props;

  return (
    <div className={cn("modal-content", ["processing"])}>
      <Loading />
      <div className={cn("loading-text")}>{copy.processing}</div>
    </div>
  );
};
